import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Layout from './components/Layout.vue';
import Global from './components/Global.vue';
import axios from 'axios';


Vue.use(ElementUI);
Vue.prototype.Global = Global;
Vue.prototype.$axios=axios;
Vue.prototype.getSessionStorage=function(item){
  return sessionStorage.getItem(item);
}
Vue.prototype.setSessionStorage=function(item,val){
  return sessionStorage.setItem(item,val);
}
Vue.prototype.removeSessionStorage=function(item){
  return sessionStorage.removeItem(item);
}
Vue.prototype.getLocalStorage=function(item){
  return localStorage.getItem(item);
}
Vue.prototype.setLocalStorage=function(item,val){
  return localStorage.setItem(item,val);
}
Vue.prototype.removeLocalStorage=function(item){
  return localStorage.removeItem(item);
}



new Vue({
  el: '#app',
  router,
  render: h => h(Layout)
});
